import React, { useState } from "react";
import {
    Box,
    Tabs,
    Tab,
    Typography,
    useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CompanyDetailsTab from "../components/company/CompanyDetailsTab";
import CompanyEmployeesTab from "../components/company/CompanyEmployeesTab";

function TabPanel({ children, value, index }) {
    return value === index ? (
        <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
        </Box>
    ) : null;
}

function CompanySettings() {
    const [tab, setTab] = useState(0);
    const { t } = useTranslation();
    const theme = useTheme();

    const handleChange = (event, newValue) => setTab(newValue);

    const tabLabels = [
        t("companySettings.details"),
        t("companySettings.employees"),
        t("companySettings.roles"),
        t("companySettings.billing"),
        t("companySettings.activity"),
    ];

    const renderTabContent = () => {
        switch (tab) {
            case 0:
                return <CompanyDetailsTab />;
            case 1:
                return <CompanyEmployeesTab />;
            case 2:
                return <CompanyEmployeesTab />;
            case 3:
                return <CompanyEmployeesTab />;
            case 4:
                return <CompanyEmployeesTab />;
            default:
                return null;
        }
    };

    return (
        <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
            <Tabs
                value={tab}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                TabIndicatorProps={{ style: { display: "none" } }} // hide default indicator
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    "& .MuiTab-root": {
                        textTransform: "none",
                        fontWeight: 500,
                        minWidth: 120,
                        color: theme.palette.text.primary,
                    },
                    "& .Mui-selected": {
                        backgroundColor: "gray",
                        color: "#ffffff",
                        borderBottom: "3px solid #ffffff", // custom white underline
                    },
                }}
            >
                {tabLabels.map((label, index) => (
                    <Tab key={index} label={label} />
                ))}
            </Tabs>

            <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
                {renderTabContent()}
            </Box>
        </Box>
    );
}

export default CompanySettings;
